'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Affix = require('./Affix');

var _Affix2 = _interopRequireDefault(_Affix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _Affix2["default"];
module.exports = exports['default'];